/* Páginas de kit en Shopify (Claude Code, 2026-10-05). Los textos, fotos y precios están en
   las secciones (editables desde Shopify); esto solo hace que las cosas se muevan. */
function kitTienda() {
  /* Lo que se dejó vacío en el editor sigue a la campaña activa (CyberMonday, Halloween...). */
  const campana = { hero: () => `${STORE.offerName}: termina el ${STORE.offerEndText}`, nombre: () => STORE.offerName,
    fin: () => `Termina el ${STORE.offerEndText}`, porque: () => STORE.offerWhy };
  document.querySelectorAll('[data-campana]').forEach((el) => {
    if (!el.textContent.trim() && campana[el.dataset.campana]) el.textContent = campana[el.dataset.campana]();
  });

  // deslizador antes / después
  const ba = document.querySelector('.ba'), range = document.getElementById('ba-range');
  if (ba && range) {
    const set = (v) => ba.style.setProperty('--pos', v + '%');
    range.addEventListener('input', () => set(range.value));
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        const seq = [50, 22, 78, 50], t0 = performance.now(), dur = 2200;
        const run = (t) => {
          const p = Math.min(1, (t - t0) / dur), seg = Math.min(2, Math.floor(p * 3)), local = p * 3 - seg;
          const ease = 0.5 - Math.cos(local * Math.PI) / 2;
          const v = seq[seg] + (seq[seg + 1] - seq[seg]) * ease;
          set(v); range.value = v;
          if (p < 1) requestAnimationFrame(run);
        };
        requestAnimationFrame(run);
      }, { threshold: 0.6 });
      io.observe(ba);
    }
  }

  // barra fija: aparece después de la portada y se esconde en las ofertas
  const bar = document.querySelector('.buybar'), hero = document.querySelector('.kit-hero'), offer = document.getElementById('ofertas');
  if (bar && hero && offer) {
    let pastHero = false, inOffer = false;
    const upd = () => { const on = pastHero && !inOffer; bar.classList.toggle('show', on); document.body.classList.toggle('has-buybar', on); };
    new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting; upd(); }).observe(hero);
    new IntersectionObserver(([e]) => { inOffer = e.isIntersecting; upd(); }, { threshold: 0.25 }).observe(offer);
  }

  // el resumen muestra el pack elegido
  const elegido = () => document.querySelector('input[name="pack"]:checked');
  const sync = () => {
    const v = elegido() && elegido().value;
    document.querySelectorAll('[data-stack-pack]').forEach((s) => { s.hidden = s.dataset.stackPack !== v; });
    if (document.body.classList.contains('has-disc')) {
      document.querySelectorAll('[data-stack-pack] .disc-line').forEach((d) => { d.textContent = (window.AS && AS.juegoTextos && AS.juegoTextos.linea_kit) || 'El kit ya tiene precio de oferta'; });
    }
  };
  document.querySelectorAll('input[name="pack"]').forEach((r) => r.addEventListener('change', sync));
  sync();

  // pedido y venta adicional
  const modal = document.querySelector('.modal'), pedir = document.querySelector('[data-order]');
  if (!modal || !pedir) return;
  const open = () => { modal.classList.add('open'); modal.querySelector('[data-upgrade]').focus(); };
  const close = () => modal.classList.remove('open');
  pedir.addEventListener('click', () => {
    const r = elegido();
    if (r && r.value === 'basico') open(); else ASTienda.pedirKit(+(r ? r.dataset.cant : 3));
  });
  modal.querySelector('[data-upgrade]').addEventListener('click', () => {
    const c = document.getElementById('pack-completo');
    c.checked = true; sync(); close(); ASTienda.pedirKit(+c.dataset.cant);
  });
  modal.querySelector('[data-decline]').addEventListener('click', () => { close(); ASTienda.pedirKit(+document.getElementById('pack-basico').dataset.cant); });
  modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
  addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
}
